export default {"src":"/_next/static/media/logo-grey.b4ff2626.svg","height":104,"width":234,"blurWidth":0,"blurHeight":0};